import {
  login,
} from "../../../helpers/auth_helper";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';
import {authUserManager} from "../../../helpers/api_helper";
import {postLoginGuest} from "../../../helpers/user_helper";
import {loginGuestSuccess, loginGuestError} from "../profile/reducer";

export const loginUser = (user, history) => async (dispatch) => {
  try {
    let response;
    response = login({
      email: user.email,
      password: user.password
    });

    var data = await response;

    if (data) {
      authUserManager.setAuthUser(data)
        dispatch(loginSuccess(data));
        history('/admin/event/' + data.eventId)
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    authUserManager.removeAuthUser()
      dispatch(logoutUserSuccess(true));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const loginGuestUser = (user) => async (dispatch) => {
  try {
    let response;
    response = postLoginGuest(user);

    var data = await response;

    if (data) {
      authUserManager.setGuest(data)
      dispatch(loginGuestSuccess(data))
    }
  } catch (error) {
    dispatch(loginGuestError(error));
  }
};
